import type { PayloadAction } from '@reduxjs/toolkit';
import type { IProcosState } from '../../../../types';

export const workItemReducers = {
  setEditMode(state: IProcosState, action: PayloadAction<any>) {
    state.isEditMode = action.payload.isEdit;
  },
  setActiveWorkItem(state: IProcosState, action: PayloadAction<any>) {
    state.activeWorkItem = action.payload;
  },
  setNewWorkItem(state: IProcosState, action: PayloadAction<any>) {
    state.newWorkItem = action.payload;
  },
};
